/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Err_User_DisabledInputs */

const en_adm_err_user_disabled = /** @type {(inputs: Adm_Err_User_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable the account first.`)
};

const de_adm_err_user_disabled = /** @type {(inputs: Adm_Err_User_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiviere zuerst das Konto.`)
};

/**
* | output |
* | --- |
* | "Enable the account first." |
*
* @param {Adm_Err_User_DisabledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_err_user_disabled = /** @type {((inputs?: Adm_Err_User_DisabledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Err_User_DisabledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_err_user_disabled(inputs)
	return en_adm_err_user_disabled(inputs)
});